import { createContext, useContext } from "react";

export const SidebarContext = createContext(null);
export const useSidebarContext = () => useContext(SidebarContext);
